import { render } from "./priceDisplay.vue?vue&type=template&id=4fd146eb&scoped=true"
const script = {}

import "./priceDisplay.vue?vue&type=style&index=0&id=4fd146eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd146eb"]])

export default __exports__